import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Nunca pensé que podía aprender, hoy ya toco mis primeras canciones',
    name: 'María González',
    age: '58 años'
  }, {
    quote: 'A los 65 empecé y no puedo parar. Es adictivo.',
    name: 'Jorge Fernández',
    age: '65 años'
  }, {
    quote: 'Simple, claro y sin vueltas. Justo lo que necesitaba.',
    name: 'Susana López',
    age: '47 años'
  }];
  return <section className="py-20 bg-beige relative overflow-hidden" data-id="element-154">
      <div className="absolute top-10 right-0 w-72 h-72 bg-gold/8 rounded-full blur-3xl translate-x-1/3" data-id="element-155"></div>
      <div className="absolute bottom-10 left-0 w-56 h-56 bg-navy/[0.03] rounded-full blur-3xl -translate-x-1/4" data-id="element-156"></div>
      <div className="absolute top-1/2 left-[60%] text-navy/[0.04] text-7xl font-serif select-none pointer-events-none" data-id="element-157">
        ♬
      </div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-16" data-id="element-160">
            Historias de éxito reales
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-161">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-162">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-navy/5 h-full flex flex-col" data-id="element-163">
                <div className="flex gap-1 mb-6" data-id="element-164">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-165" />)}
                </div>
                <p className="text-lg text-navy/80 italic mb-8 flex-grow" data-id="element-166">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-beige pt-4" data-id="element-167">
                  <p className="font-bold text-navy text-lg" data-id="element-168">
                    {testimonial.name}
                  </p>
                  <p className="text-navy/60 text-sm" data-id="element-169">{testimonial.age}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}